import { get, post } from './index';

export const sendVerificationMessage = () => {
  return get(`verify-communication`);
};

export const verifyCommunication = data => {
  return post(`verify-communication`, data);
};
